import { useTranslation } from "react-i18next";
import {
  ProgramSingleTrainingSider,
  ExerciseSiderSearch,
  ExerciseSiderCardsWrapper,
} from "../style";
import { useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../../store/config";
import { useParams } from "react-router-dom";
import { useDebounce } from "../../../../../../../../../hooks/useDebounce";
import { PAGE_SIZE } from "../../../../../../../../../common/config";
import { fetchExercisesStart } from "../../../../../../../../../store/features/exercises/exercises-slice";
import { Flex, Pagination, Spin } from "antd";
import { DraggableExerciseSiderCard } from "./DraggableExerciseCards";

import { SearchOutlined } from "@ant-design/icons";

const ExercisesOptions = ({ isEditable }: { isEditable: boolean }) => {
  const { id: trainerId } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [searchValue, setSearchValue] = useState<string>("");
  const dispatch = useAppDispatch();
  const { exercises, loading, error, metadata } = useAppSelector(
    (state) => state.exercises
  );
  const debouncedSearch = useDebounce(searchValue, 300);

  useEffect(() => {
    dispatch(
      fetchExercisesStart({
        filter: { trainer: trainerId },
        search: debouncedSearch,
        pagination: { limit: PAGE_SIZE, page: 0, skip: 0 },
        sort: { sortBy: "updatedAt", sortOrder: -1 },
      })
    );
  }, [debouncedSearch, trainerId, dispatch]);

  const onPaginationChange = (page: number) => {
    dispatch(
      fetchExercisesStart({
        filter: { trainer: trainerId },
        search: debouncedSearch,
        sort: { sortBy: "updatedAt", sortOrder: -1 },
        pagination: { limit: PAGE_SIZE, page, skip: PAGE_SIZE * (page - 1) },
      })
    );
  };

  return (
    <ProgramSingleTrainingSider
      title={t("Training Program")}
      collapsed={!isEditable}
      collapsible={true}
      width={"30%"}
      collapsedWidth={0}
      trigger={null}
    >
      <ExerciseSiderSearch
        placeholder={t("Search for exercises")}
        onChange={(e) => setSearchValue(e.target.value)}
        prefix={<SearchOutlined />}
      />
      {exercises.length > 0 ? (
        <Spin spinning={loading}>
          <ExerciseSiderCardsWrapper>
            {exercises.map((exercise, index) => (
              <DraggableExerciseSiderCard exercise={exercise} key={index} />
            ))}
          </ExerciseSiderCardsWrapper>

          <Pagination
            current={metadata?.page}
            pageSize={PAGE_SIZE}
            total={metadata?.total}
            align="center"
            hideOnSinglePage
            onChange={onPaginationChange}
            showSizeChanger={false}
            style={{ direction: "ltr", marginTop: "60px" }}
          />
        </Spin>
      ) : (
        <Flex justify="center">{t("Empty")}</Flex>
      )}
    </ProgramSingleTrainingSider>
  );
};
export default ExercisesOptions;
